import { setTag, setUser } from "@sentry/nextjs";

/** Browser identity comes from server page props, including the runtime node alias. */
export function setSentryIdentity(
    visitId?: string,
    domainName?: string,
    nodeMark?: string,
): void {
    if (typeof window === "undefined") return;

    const domain = domainName || window.location.hostname;
    setTag("domainName", domain);
    setTag("visitId", visitId || undefined);
    setTag("nodeMark", nodeMark || undefined);
    setUser(visitId ? { id: visitId, email: `${visitId}@${domain}` } : null);
}
